export enum ExpressionType {
  FUNCTION = 'function',
  ALERT = 'alert'
}
